import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { DonationForm } from "@/components/DonationForm";
import { useLanguage } from "@/contexts/LanguageContext";

const Donate = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                {t("donate.title")}
              </h1>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                {t("donate.subtitle")}
              </p>
            </div>
            
            <div className="bg-card rounded-lg shadow-lg p-6 md:p-8 mb-8">
              <DonationForm defaultCategory="church" />
            </div>

            <div className="grid md:grid-cols-3 gap-6 mt-12">
              <div className="bg-card rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🙏</span>
                </div>
                <h3 className="font-semibold mb-2">{t("donate.support.title")}</h3>
                <p className="text-sm text-muted-foreground">
                  {t("donate.support.description")}
                </p>
              </div>

              <div className="bg-card rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🌍</span>
                </div>
                <h3 className="font-semibold mb-2">{t("donate.missions.title")}</h3>
                <p className="text-sm text-muted-foreground">
                  {t("donate.missions.description")}
                </p>
              </div>

              <div className="bg-card rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">💝</span>
                </div>
                <h3 className="font-semibold mb-2">{t("donate.community.title")}</h3>
                <p className="text-sm text-muted-foreground">
                  {t("donate.community.description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Donate;
